export const lookupTypes = {
    UserTypes: 1,
    UnitTypes: 2,
    SocialStatus: 3,
    BloodTypes:4,
    DiseasesTypes: 5,
    SkinIssuesTypes: 6,
    AppointmentTypes: 8,
    StoreTypes: 9,
    MedicineTypes: 10,
    AnalysisGroups: 11,
    paymentTypes: 12,
    InvoiceTypes: 13,
    PaymentMethod: 15,
    ProcedureTypes: 16,

};
export const status = {
    dataEnter: 10,
    active: 1,
    locked: 2,
    rejected: 4,
    approved: 5,
    review:7,
    expired: 11,
    cancel:15,
    replyed:16,
};


export const gender = {
    male: 1,
    female: 2
};
export const attachmentTypes = {
    PersonalPic: 1,
    PassportPic: 2,
    EmploymentPic : 3,
    StartingPic: 4,
    ChequePic: 5,
    HealthFile:6,
    CourseFile: 7,
    QualificationFile: 8,   
};